import type { CallState } from '../WebRTCCallService';

export const AGENT_PHONE_CHANNEL = 'cwy-agent-voice-v1';
export const AGENT_PHONE_WINDOW_NAME = 'cwy-agent-phone';
/** Minimum viewport for the agent phone pop-out (CSS + window default size). */
export const AGENT_PHONE_MIN_WIDTH_PX = 390;
export const AGENT_PHONE_MIN_HEIGHT_PX = 680;
export const AGENT_PHONE_DEFAULT_WIDTH_PX = 420;
export const AGENT_PHONE_DEFAULT_HEIGHT_PX = 860;
export const PENDING_SCREEN_POP_KEY = 'cwy-pending-screen-pop';
/** Outbound dial queued from CRM before opening Agent Phone (localStorage, cross-tab). */
export const PENDING_OUTBOUND_DIAL_KEY = 'cwy-pending-outbound-dial';
/** Set when the browser blocked the Agent Phone pop-out (sessionStorage). */
export const AGENT_PHONE_POPUP_BLOCKED_KEY = 'cwy-agent-phone-popup-blocked';
/** Set once Agent Phone was opened successfully this browser session. */
export const AGENT_PHONE_SESSION_PRIMED_KEY = 'cwy-agent-phone-session-primed';

export interface PendingOutboundDial {
  message: AgentPhoneOutboundMessage;
  at: number;
}

export type AgentPhoneOutboundMessage =
  | {
      type: 'DIAL_PSTN';
      requestId: string;
      phoneNumber: string;
      clientName?: string;
      clientId?: string;
      agentId?: string;
      channel?: CallState['channel'];
    }
  | {
      type: 'DIAL_APP';
      requestId: string;
      clientId: string;
      clientName: string;
      agentId: string;
      agentDisplayName: string;
    };

export type AgentPhoneToCrmMessage =
  | { type: 'CALL_STATE'; state: CallState }
  | { type: 'STATE_SYNC'; state: CallState }
  | {
      type: 'SCREEN_POP';
      clientId?: string | null;
      clientName?: string | null;
      clientPhone?: string | null;
      threadId?: string | null;
      callSid?: string | null;
    }
  | { type: 'DIAL_RESULT'; requestId: string; ok: boolean; error?: string }
  | { type: 'PHONE_READY' }
  | { type: 'PONG' };

export type AgentPhoneCrmMessage =
  | AgentPhoneOutboundMessage
  | { type: 'PING' }
  | { type: 'STATE_REQUEST' };

export interface PendingScreenPop {
  clientId?: string | null;
  clientName?: string | null;
  clientPhone?: string | null;
  threadId?: string | null;
  at: number;
}
